import React, { Component } from 'react'
import './hero.scss'
import moment from 'moment'
import config from '../../../../data/SiteConfig'
import { Link } from 'gatsby'

class Hero extends Component {
  constructor(props) {
    super(props)
    this.state = {
      frontmatter: props.blogInfo.markdownRemark.frontmatter,
      timeToRead: props.blogInfo.markdownRemark.timeToRead,
      date: props.blogInfo.markdownRemark.fields.date,
    }
  }

  render() {
    return (
      <div>
        <div className="blog-post-hero">
          <Link
            to={'/blog/' + this.state.frontmatter.category}
            className="header-blog-info"
          >
            <i className="fa fa-file-text-o"></i> Blog Post •{' '}
            {this.state.frontmatter.category}
          </Link>
          <div>
            <h2 className="light">{this.state.frontmatter.title}</h2>
          </div>
          <span className="date">
            <i className="fa fa-calendar"></i>{' '}
            {moment(this.state.date).format(config.dateFormat)}
          </span>
          <span>by {this.state.frontmatter.author.full_name}</span>
          <span>
            <i className="fa fa-clock-o"></i> {this.state.timeToRead} min read
          </span>
        </div>
      </div>
    )
  }
}

export default Hero
